<!-- filepath: /Users/martinasell/Documents/XDL/Projects/xylemsprout-web/gravity-angular-ui/src/app/managed-services/gso-ami-saas/resync-dialog/resync-dialog.component.html -->
<h2 mat-dialog-title>Select Month and Year</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>Month/Year</mat-label>
    <input matInput [matDatepicker]="picker" [formControl]="date" [max]="maxDate" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker
      #picker
      startView="multi-year"
      (monthSelected)="onMonthSelected($event, picker)"
      panelClass="month-picker"
    ></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirmSelection()">Confirm</button>
</mat-dialog-actions>